const mapStateToThis = ({ dictionary }) => {
  const { userClass } = dictionary;
  return {
    dictionary: userClass,
  };
};

const mapDispatchToThis = {};

@Inject('$ngRedux')
export class RwUserClassController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-user-class/rw-user-class-controller.js